import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  TripAddress,
  TripAddressFilters,
  TripAddressSort
} from '../../lib/types/models/trip-address/trip-address'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripAddresses(
  input: PaginationRequest<TripAddressFilters, string, Version, TripAddressSort> = {}
) {
  if (!input.sort) input.sort = { label: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.tripAddresses.getAll.url, null), input))
    .get<PaginationResponse<TripAddress>>()
}
